import Swiper from 'swiper';
import { Navigation, Pagination, FreeMode, Thumbs, Autoplay, Zoom, Grid, Mousewheel } from 'swiper/modules';
import safeJSONParse from '../utils/safeJsonParse';
import { BREAKPOINTS, SWIPER } from '../utils/constants';

// Standart Swiper init
const initSwiper = (slider = null) => {
  const swipers = slider ? [slider] : document.querySelectorAll('[data-swiper]');
  const thumbSwipers = [];

  if (!swipers.length) return;

  window.theme.swiperObjects = [];

  swipers.forEach(swiper => {
    const slides = swiper.querySelectorAll(SWIPER.SLIDE_CLASS);
    let config = swiper.dataset.swiperConfig ? safeJSONParse(swiper.dataset.swiperConfig, false) : {};
    const swiperModules = [];
    !config ? console.error('Error in Swiper JSON') : null;
    if (slides.length && config) {
      // Swiper operates by loading modules, that's why we check if a module is referenced in the configuration. If it is, we add it to the modules array.
      if ('navigation' in config) {
        swiperModules.push(Navigation);
      }
      if ('pagination' in config) {
        swiperModules.push(Pagination);
      }
      if ('freeMode' in config) {
        swiperModules.push(FreeMode);
      }
      if ('autoplay' in config) {
        swiperModules.push(Autoplay);
      }
      if ('mousewheel' in config) {
        swiperModules.push(Mousewheel);
      }
      if ('thumbs' in config) {
        swiperModules.push(Thumbs);
        thumbSwipers.forEach(thumbSwiper => {
          config = { ...config, ...{ thumbs: { swiper: thumbSwiper } } };
        });
      }
      if ('zoom' in config) {
        swiperModules.push(Zoom);
      }

      // Adding modules to the config
      config = { ...config, ...{ modules: swiperModules } };

      swiper.classList.add('swiper--active');
      const newSwiper = new Swiper(swiper, config);
      if (swiper.dataset.swiperThumbs) {
        thumbSwipers.push(newSwiper);
      }

      window.theme.swiperObjects.push(newSwiper);

      const videoSlides = swiper.querySelectorAll('[data-slide-video]');
      if (videoSlides.length) {
        const syncVideoPlayback = () => {
          videoSlides.forEach(slide => {
            const video = slide.querySelector('video');
            if (!video) return;
            if (slide.classList.contains('swiper-slide-active')) {
              video.play();
            } else {
              video.pause();
              video.currentTime = 0;
            }
          });
        };
        newSwiper.on('slideChangeTransitionEnd', syncVideoPlayback);
      }
    }
  });
};

// Init swiper for mobile and tablet only
const initSwiperMobile = (slider = null) => {
  const desktopMediaQuery = window.matchMedia(`(min-width: ${BREAKPOINTS.DESKTOP}px)`);
  const swipers = slider ? [slider] : document.querySelectorAll('[data-swiper-mob]');

  if (!swipers.length) return;

  window.theme.swiperMobileObjects = [];

  const initSwiperOnMobile = () => {
    if (!desktopMediaQuery.matches) {
      swipers.forEach(swiper => {
        const slides = swiper.querySelectorAll(SWIPER.SLIDE_CLASS);
        let config = swiper.dataset.swiperConfig ? safeJSONParse(swiper.dataset.swiperConfig, false) : {};
        const swiperModules = [];
        !config ? console.error('Error in Swiper JSON') : null;
        if (slides.length && config) {
          if ('navigation' in config) {
            swiperModules.push(Navigation);
          }
          if ('pagination' in config) {
            swiperModules.push(Pagination);
          }
          if ('freeMode' in config) {
            swiperModules.push(FreeMode);
          }
          if ('thumbs' in config) {
            swiperModules.push(Thumbs);
          }
          if ('zoom' in config) {
            swiperModules.push(Zoom);
          }
          if ('grid' in config) {
            swiperModules.push(Grid);
          }

          config = { ...config, ...{ modules: swiperModules } };
          swiper.classList.add('swiper--mob-active');
          const newSwiper = new Swiper(swiper, config);
          window.theme.swiperMobileObjects.push(newSwiper);

        }
      });
    } else {
      if (window.theme.swiperMobileObjects) {
        window.theme.swiperMobileObjects.forEach(swiper => {
          swiper.destroy();
        });
        const keys = Object.keys(window.theme.swiperMobileObjects);
        keys.forEach(key => window.theme.swiperMobileObjects[key].destroy());
        window.theme.swiperMobileObjects = [];
      }
    }
  };
  if (desktopMediaQuery) {
    initSwiperOnMobile();
  }
  desktopMediaQuery.addEventListener('change', initSwiperOnMobile);
};

export { initSwiper, initSwiperMobile };
